import { html, TemplateResult } from 'lit/html.js';
import { choose } from 'lit/directives/choose.js';
import CloseButtonTemplate from '@libs/modal/closeButton';
import { WelcomeModalTemplate, ErrorModalTemplate } from "@components/commonTemplate";
import MySearchesTemplate from "./mySearches";
import FormTemplate from './form';
import LocationPreferenceTemplate from './locationPreference';

const ModalProposalTemplate = async (config: ProposalConfigs, model: IProposalModel): Promise<TemplateResult> => {
  const {
    messages,
    feature: {
      confirmationSingleClickEnabled
    }
  } = config;
  const {
    close,
    modalState,
    socialSubscriptionError,
    linkToInboxProviderUrl,
    formData,
    LocationPreferenceAcknowledgment
  } = model;
  const welcomeTemplateProps: IWelcomeModalTemplateProps = {
    messages,
    close,
    linkToInboxProviderUrl,
    email: formData.email?.value,
    LocationPreferenceAcknowledgment,
    source: confirmationSingleClickEnabled ? 'welcome' : 'confirmation_reminder'
  };

  return html`
    <div class="js-modal-skeleton">
      <div class="proposal">
        ${CloseButtonTemplate(close)}
        ${choose(modalState, [
    ['proposal', () => FormTemplate(config, model)],
    ['locationPreference', () => LocationPreferenceTemplate(messages, model)],
    ['mySearches', () => MySearchesTemplate(config, model)],
    ['welcome', () => WelcomeModalTemplate(welcomeTemplateProps)],
    ['error', () => ErrorModalTemplate({ messages, close, socialSubscriptionError })],
  ],
    () => ErrorModalTemplate({ messages, close, socialSubscriptionError }))}
      </div>
    </div>`;
}

export default ModalProposalTemplate;
